import {confirmAlert} from 'react-confirm-alert'
import {toast} from 'react-toastify'
import styled from 'styled-components'
import {withStyles} from '@material-ui/core/styles'
import {ReactSVG} from 'react-svg'
import Step from '../_Step'
import Hero from '../../../card/components/Hero'
import Grid from '../../../card/components/Grid'
import {AddPopup, EditPopup} from '../PointPopups'

class Customize extends Step
	constructor: ()->
		super(arguments...)
		@openPopup = @openPopup.bind(@)
		@closePopup = @closePopup.bind(@)
		@handlePointAdd = @handlePointAdd.bind(@)
		@handlePointEdit = @handlePointEdit.bind(@)
		@handlePointRemove = @handlePointRemove.bind(@)
		@state =
			interacted: @props.formState.values.contactPoints?.length > 0
			popupopen:
				add: false
				edit: false
				data: null
	
	render: ()->
		data = @props.formState.values
		color = data.color
		points = @props.formState.values.contactPoints or []
		
		root =
		<Wrapper key={0}>
			<Hero card={data} color={color} />
			<Grid card={data} color={color}
				points={data.contactPoints}
				handleClick={@handlePointClick.bind(@)}
				min={6} interactive demo
			/>
			{unless @state.interacted
				<ReactSVG
					src="/files/img/point-arrow-2.svg"
					beforeInjection={(svg)=>
						svg.classList.add @props.classes.arrow
						if data.company
							svg.classList.add @props.classes.arrowShiftDown
					}
				/>
			}
			<EditPopup
				open={@state.popupopen.edit}
				point={@state.popupopen.data}
				points={points}
				openPopup={@openPopup}
				closePopup={@closePopup}
				handlePointEdit={@handlePointEdit}
				handlePointRemove={@handlePointRemove}
			/>
			<AddPopup
				open={@state.popupopen.add}
				points={points}
				openPopup={@openPopup}
				closePopup={@closePopup}
				handlePointAdd={@handlePointAdd}
			/>
		</Wrapper>
		
		super([root])
	
	onNextStep: ()->
		fbq?('trackCustom', 'FilledCustomize')
		email = @props.formState.values?.contactPoints.find(type:'email')?.value
		if email
			app.logrocket?.identify?(email)
	
	validate: ()->
		valid = true
		
		unless @props.formState.values.contactPoints?.length > 1
			toast.error "You must add at least 2 contact points"
			valid = false
		
		return {valid}
	
	openPopup: (target, data)->
		@setState popupopen:{@state.popupopen..., [target]:true, data}
	
	closePopup: (target)->
		@setState popupopen:{@state.popupopen..., [target]:false, data:null}
	
	handlePointAdd: (point)->
		if @doesSamePointExist(point)
			confirmDuplicatePointAdd().then (proceed)=> if proceed
				@addPoint(point)
		else
			@addPoint(point)
	
	handlePointEdit: (oldPoint, newPoint)->
		@editPoint(oldPoint, newPoint)
	
	handlePointRemove: (point)->
		confirmRemovePoint(point).then (proceed)=> if proceed
			@removePoint(point)
			@closePopup('edit')
	
	handlePointClick: (point)->
		@setState interacted:true
		if point is 'placeholder'
			@openPopup('add')
		else
			@openPopup('edit', point)
	
	doesSamePointExist: (point)->
		contactPoints = @props.formState.values.contactPoints or []

		for siblingPoint in contactPoints
			if siblingPoint.type is point.type and siblingPoint.value is point.value
				return true
		
		return false
	
	addPoint: (point)->
		{values} = @props.formState
		contactPoints = values.contactPoints or []
		
		@props.updateForm values: {values..., contactPoints:[contactPoints..., point]}
	
	editPoint: (oldPoint, newPoint)->
		{values} = @props.formState
		contactPoints = values.contactPoints.slice()
		pointIndex = contactPoints.indexOf(oldPoint)
		contactPoints.splice(pointIndex, 1, newPoint)
		
		@props.updateForm values: {values..., contactPoints}
	
	removePoint: (point)->
		{values} = @props.formState
		contactPoints = values.contactPoints.slice()
		pointIndex = contactPoints.indexOf(point)
		contactPoints.splice(pointIndex, 1)
		
		@props.updateForm values: {values..., contactPoints}


	
confirmDuplicatePointAdd = ()-> new Promise (resolve)=>
	confirmAlert(
		title: "Duplicate contact point exists"
		message: "A contact point similar to this one has already been added before. Do you want to add it anyway?"
		buttons: [
			label: 'Yes'
			onClick: ()=> resolve(true) 
		,
			label: 'No'
			onClick: ()-> resolve(false)
		]
	)

confirmRemovePoint = (point)-> new Promise (resolve)=>
	confirmAlert(
		title: "Confirm removal"
		message: "Are you sure you want to remove this contact point \"#{point.label}\"?"
		buttons: [
			label: 'Yes'
			onClick: ()=> resolve(true) 
		,
			label: 'No'
			onClick: ()-> resolve(false)
		]
	)



Wrapper = styled.div"""
	overflow: hidden
	box-sizing: border-box
	width: 100%
	max-width: 415px
	margin: -40px auto 0;
	transform: scale(0.8);
	border: 8px solid #dee3e8;
	border-radius: 5px
	@media(max-width:812px) {
		transform: scale(0.9);
	}
"""

styles =
	arrow:
		zIndex: 5
		position: 'absolute'
		left: '43%'
		top: '119px'
		width: '120px'
		animation: '$pulse 1400ms infinite'
		transform: 'rotateX(180deg)'
		pointerEvents: 'none'
	
	arrowShiftDown:
		top: '140px'
	
	'@keyframes pulse':
		'0%': opacity:0
		'35%': opacity:1
		'65%': opacity:1
		'100%': opacity:0

export default withStyles(styles)(Customize)